import React, { useState } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import useSizeDetector from '../hooks/useSizeDetector';

import HeaderLogoImg from '../assets/images/header/logo.png';
import ServiceAtsentImg from '../assets/images/header/service_atsent.svg';
import ServiceReviewaidImg from '../assets/images/header/service_reviewaid.svg';
import MobileMenuImg from '../assets/images/header/mobile_menu.png';

const Header = () => {
	const { Desktop, Mobile } = useSizeDetector();
	const [showMobileMenu, setShowMobileMenu] = useState(false);

	return (
		<Container>
			<Desktop>
				<Content>
					<LeftMenuContainer>
						<Link to="/">
							<HeaderLogo src={HeaderLogoImg} />
						</Link>
						<MenuItems>
							<MenuItem>
								<Link to="/reviewaid" activeStyle={{ color: '#4ba4f8' }}>
									리뷰에이드
								</Link>
							</MenuItem>
							<MenuItem>
								<Link to="/atsent" activeStyle={{ color: '#4ba4f8' }}>
									엣센트
								</Link>
							</MenuItem>
							<MenuItem>
								<Link to="/company" activeStyle={{ color: '#4ba4f8' }}>
									회사소개
								</Link>
							</MenuItem>
							<MenuItem>
								<Link to="/recruit" activeStyle={{ color: '#4ba4f8' }}>
									채용
								</Link>
							</MenuItem>
						</MenuItems>
					</LeftMenuContainer>
					<RightMenuContainer>
						<ServiceButton onClick={() => window.open('https://svc.atsent.ai/')}>
							<ServiceLogo src={ServiceAtsentImg} />
						</ServiceButton>
						<ServiceButton onClick={() => window.open('https://www.reviewaid.ai/')}>
							<ServiceLogo src={ServiceReviewaidImg} />
						</ServiceButton>
					</RightMenuContainer>
				</Content>
			</Desktop>
			<Mobile>
				<Content>
					<LeftMenuContainer>
						<Link to="/">
							<HeaderLogo src={HeaderLogoImg} />
						</Link>
					</LeftMenuContainer>
					<RightMenuContainer>
						<MobileMenu src={MobileMenuImg} onClick={() => setShowMobileMenu(!showMobileMenu)} />
					</RightMenuContainer>
					{showMobileMenu && (
						<MobileMenuContainer>
							<MobileMenuLink to="/reviewaid" activeStyle={{ backgroundColor: '#f7f9fb' }}>
								리뷰에이드
							</MobileMenuLink>
							<MobileMenuLink to="/atsent" activeStyle={{ backgroundColor: '#f7f9fb' }}>
								엣센트
							</MobileMenuLink>
							<MobileMenuLink to="/company" activeStyle={{ backgroundColor: '#f7f9fb' }}>
								회사소개
							</MobileMenuLink>
							<MobileMenuLink to="/recruit" activeStyle={{ backgroundColor: '#f7f9fb' }}>
								채용
							</MobileMenuLink>
						</MobileMenuContainer>
					)}
				</Content>
			</Mobile>
		</Container>
	);
};

const Container = styled.div`
	position: fixed;
	width: 100vw;
	height: 80px;

	display: flex;
	justify-content: center;
	z-index: 100;
	background-color: white;

	@media only screen and (max-width: 767.98px) {
		height: 60px;
	}
`;

const Content = styled.div`
	width: 100%;
	max-width: 1352px;
	height: 100%;
	padding: 0 16px;

	display: flex;
	align-items: center;
	justify-content: space-between;

	@media only screen and (max-width: 767.98px) {
		max-width: none;
		padding: 0;
	}
`;

const HeaderLogo = styled.img`
	width: 109px;
	height: auto;
	cursor: pointer;

	@media only screen and (max-width: 767.98px) {
		width: 85px;
		margin-left: 16px;
	}
`;

const LeftMenuContainer = styled.div`
	display: flex;
	align-items: center;
`;

const MenuItems = styled.div`
	display: flex;
	margin-left: 60px;
`;

const MenuItem = styled.div`
	font-size: 16px;
	font-weight: 700;
	line-height: 16px;
	cursor: pointer;

	& + & {
		margin-left: 40px;
	}
`;

const RightMenuContainer = styled.div`
	display: flex;
	align-items: center;
`;

const ServiceButton = styled.div`
	width: 98px;
	height: 42px;

	display: flex;
	align-items: center;
	justify-content: center;

	border: 1px solid #e8e8e8;
	box-sizing: border-box;
	box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	cursor: pointer;

	& + & {
		margin-left: 20px;
	}
`;

const ServiceLogo = styled.img`
	width: 70px;
	height: auto;
`;

const MobileMenu = styled.img`
	width: 19.5px;
	height: auto;
	margin-right: 16px;
`;

const MobileMenuContainer = styled.div`
	position: absolute;
	top: 60px;

	width: 100vw;
	height: 196px;
	padding: 10px 0;
	box-sizing: border-box;

	background-color: white;
`;

const MobileMenuLink = styled(Link)`
	display: block;
	width: 100%;
	height: 44px;
	padding: 15px 20px;
	box-sizing: border-box;

	font-size: 14px;
	font-weight: 400;
	line-height: 14px;
`;

export default Header;
